import React from 'react';
import { FilePDF } from 'shared/svg/filepdf';
import { toLocale } from 'utils/filters';
import {
    LocaleBox,
    Title,
    StyledLocalStatus,
    TextWrapper,
    StyledText,
    PriceText,
    YardgeText,
    StyledButton,
} from './LocaleCard.styled';

interface LocaleProps {
    investmentSlug: string;
    localeNumber: number;
    price: number;
    status: string;
    yardge: number;
}

export const LocaleCard = ({
    investmentSlug,
    localeNumber,
    price,
    status,
    yardge,
}: LocaleProps) => {
    return (
        <LocaleBox>
            <Title>Miejsce {localeNumber}</Title>
            <StyledLocalStatus isFree={status}>{status}</StyledLocalStatus>
            <TextWrapper>
                <StyledText>Metraż</StyledText>{' '}
                <YardgeText>
                    {yardge} m<sup>2</sup>
                </YardgeText>
            </TextWrapper>
            <TextWrapper>
                <StyledText>Cena</StyledText>
                <PriceText>{toLocale(price)} zł</PriceText>
            </TextWrapper>
            <StyledButton to={'/' + investmentSlug + '/mieszkania'}>
                <FilePDF size={18} />
                Zobacz rzut miejsca
            </StyledButton>
        </LocaleBox>
    );
};
